<template>
  <div>
    <v-dialog v-model="dialog" width="800px" persistent>
      <BaseBodyDialog :title="title" :loading="loading" @close="closePopup" @save="onSubmit">
        <BaseInputSearch
          class="mt-6"
          label="Tên học viên"
          placeholder="Nhập Tên học viên"
          outlined
          hideDetails
          @onSearch="onSearch"
        />
        <div v-if="!loadingStudent">
          <v-card class="elevation-0" outlined>
            <TableAttendance
              style="max-height: 50vh; overflow-y: auto"
              ref="table-attendance"
              :search="search"
              :isStatusShown="isEditButtonShown"
              :key="id"
            />
          </v-card>
        </div>
        <div v-else :style="{ height: '300px', display: 'flex', 'justify-content': 'center', 'align-items': 'center' }">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
      </BaseBodyDialog>
    </v-dialog>
    <confirm ref="confirm" @confirm="onUpdate" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import TableAttendance from './TableAttendance.vue'
import BaseInputSearch from '../../../components/basic/input/BaseInputSearch.vue'
import BaseButton from '../../../components/basic/BaseButton.vue'
import Confirm from '../../../components/plugin/Confirm.vue'
import BaseBodyDialog from '../../../components/basic/dialog/BaseBodyDialog.vue'
import utils from '@/plugins/utils.js'

export default {
  components: {
    TableAttendance,
    BaseInputSearch,
    BaseButton,
    Confirm,
    BaseBodyDialog,
  },
  data() {
    return {
      dialog: false,
      search: '',
      isEditButtonShown: false,
      loading: false,
      title: '',
      id: '',
      date: '',
      loadingStudent: false,
      origin,
    }
  },
  computed: {
    ...mapState({
      classData(state) {
        return state['class'].clazz
      },
    }),
  },
  methods: {
    ...mapActions({
      fetchLessonAttendance: 'lessonAttendance/fetchAttendances',
      updateAttendances: 'lessonAttendance/updateAttendances',
    }),
    async openPopup({ title, date, id, isAttended }) {
      this.id = id
      this.date = moment(date).format('DD/MM/YYYY')
      this.title = `Điểm danh học viên ${title} (${this.date})`
      this.isEditButtonShown = isAttended
      this.dialog = true
    },
    async resetStudents(val) {
      if (val) {
        this.loadingStudent = true
        try {
          await this.fetchLessonAttendance({ lesson: val })
        } catch (error) {
          this.$alert.error('Không tải được Học viên, vui lòng thử lại')
        } finally {
          this.loadingStudent = false
        }
      }
    },
    closePopup() {
      this.dialog = false
      this.refresh()
    },
    refresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    getStatisticBeforeSubmit(data = []) {
      const attendedCount = data.filter((x) => x.isAttended).length
      const totalCount = data.length
      return `Có mặt <span class="green--text">${attendedCount}</span>, vắng <span class="red--text">${
        totalCount - attendedCount
      }</span> trên tổng số ${totalCount} học viên`
    },
    async onSubmit() {
      const data = this.$refs['table-attendance'].getData()
      this.$refs['confirm'].show(
        'Lưu điểm danh',
        `Các thông tin điểm danh của học viên ngày ${
          this.date
        } sẽ được lưu lại như sau:<br/>${this.getStatisticBeforeSubmit(data)}`
      )
    },
    onSearch(text) {
      this.search = utils.clearUnicode(text)
    },
    async onUpdate() {
      this.loading = true
      try {
        const data = this.$refs['table-attendance'].getData()
        if (Array.isArray(data) && data.length) {
          const attendanceData = data.map(v => ({
            student: v.student,
            isAttended: v.isAttended,
            isOnline: v.isOnline
          }))
          await this.updateAttendances({ id: this.id, data: { attendances: attendanceData } })
          setTimeout(() => {
            this.$emit('refresh')
            this.closePopup()
          }, 1000)
        }
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    id: {
      handler(val) {
        if (val && val.length) {
          this.resetStudents(val)
        }
      },
      immediate: true,
    },
  },
}
</script>
